import $t from '../i18n'

export const passwordRuleTitleConsts = {
  NUMBER: 'number',
  SMALL_LETTER: 'smallLetter',
  CAPITAL_LETTER: 'capitalLetter',
  SPECIAL_CHARACTER: 'specialCharacter',
  LENGTH: 'length',
  BE_ERROR: 'BE Error',
}

export const passwordRules = [
  {
    title: passwordRuleTitleConsts.NUMBER,
    text: $t('pages.getStarted.signupForm.passwordRules.atLeastOneNumber'),
    isValid: false,
  },
  {
    title: passwordRuleTitleConsts.SMALL_LETTER,
    text: $t('pages.getStarted.signupForm.passwordRules.atLeastOneSmallLetter'),
    isValid: false,
  },
  {
    title: passwordRuleTitleConsts.CAPITAL_LETTER,
    text: $t(
      'pages.getStarted.signupForm.passwordRules.atLeastOneCapitalLetter'
    ),
    isValid: false,
  },
  {
    title: passwordRuleTitleConsts.SPECIAL_CHARACTER,
    text: $t(
      'pages.getStarted.signupForm.passwordRules.atLeastOneSpecialCharacter'
    ),
    isValid: false,
  },
  {
    title: passwordRuleTitleConsts.LENGTH,
    text: $t(
      'pages.getStarted.signupForm.passwordRules.atLeast_8CharactersLong'
    ),
    isValid: false,
  },
]
